export const profiles = [
  {
    name: "Alyssa Feinberg '27",
    title: "Co-President",
    image: "alyssa.jpg",
  },
  {
    name: "Kathy Li '27",
    title: "Co-President",
    image: "kathy.jpeg",
  },
  {
    name: "Dior Williams '26",
    title: "Co-President",
    image: "dior.png",
  },
  {
    name: "Vivian Wang '28",
    title: "Co-Marketing Chair",
    image: "vivian.png",
  },
  {
    name: "Maggie Ruan '28",
    title: "Co-Marketing Chair",
    image: "maggie.jpeg",
  },
  {
    name: "Claire Luo '28",
    title: "Co-Mentorship Chair",
    image: "claire.JPG",
  },
  {
    name: "Lesley Martinez-Aviles '28",
    title: "Co-Mentorship Chair",
    image: "lesley.jpeg",
  },
  {
    name: "Kaitlyn Cheng '27",
    title: "Co-Development Chair",
    image: "kaitlyn.JPEG",
  },
  {
    name: "Loang Chiang '28",
    title: "Co-Development Chair",
    image: "loang.jpeg",
  },
  {
    name: "Hayzie Chu '28",
    title: "Co-Academic Events Chair",
    image: "hayzie.jpeg",
  },
  {
    name: "Jesalina Phan '27",
    title: "Co-Academic Events Chair",
    image: "jesalina.jpeg",
  },
  {
    name: "Amber Bajaj '28",
    title: "Co-Community Events Chair",
    image: "amber.jpg",
  },
  {
    name: "Valeria Quero '28",
    title: "Co-Community Events Chair",
    image: "valeria.jpg",
  },
  {
    name: "Seyoung Yang '27",
    title: "Communications Chair",
    image: "seyoung.jpg",
  },
];